<template>
  <div class="flex flex-col gap-5">
    <label class="text-lg font-bold">{{ title }}</label>
    <div class="inline-flex gap-4 border-b last:border-b-0 pb-3" v-for="index in 3" :key="index" v-if="loading">
      <div class="border rounded-sm h-10 w-12">
        <USkeleton class="w-full h-full"/>
      </div>
      <div class="flex flex-col gap-2">
        <USkeleton class="h-4 w-24"/>
        <USkeleton class="h-4 w-48"/>
      </div>
    </div>
    <div class="inline-flex gap-4 border-b last:border-b-0 pb-3" v-for="(item, index) in items" :key="index" @click="$emit('navigate', item.href)">
      <div class="flex justify-center border rounded-sm h-10 w-12 flex-shrink-0">
        <NuxtImg :src="item.avatar" loading="lazy" class="object-contain" :alt="item.label" :title="item.label" />
      </div>
      <div class="flex flex-col gap-0.5 tracking-wide">
        <p class="text-sm line-clamp-1">{{ item.label }}</p>
        <p class="text-sm text-gray-500 line-clamp-1" v-html="item.message"></p>
        <p class="text-sm text-gray-500 line-clamp-1" v-html="item.tags"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true },
  loading: { type: Boolean, required: true }
});
</script>